import React from 'react';
import { Typography, Card } from '@mui/material';
import { prettyPhone } from '../../../lib/helpers/helpers';

interface Props {
  searchBox: string;
  faxNumber: string;
}

const HeaderBar = ({ searchBox, faxNumber }: Props) => {
  return (
    <div className={searchBox}>
      <Card style={{ paddingTop: '2%', paddingLeft: '2%', paddingRight: '2%', paddingBottom: '2%' }}>
        <Typography
          variant="h5"
          component="h2"
          style={{ fontSize: 24, float: 'left' }}
        >
          Account Settings
        </Typography>

        <Typography
          variant="h5"
          component="h2"
          style={{ fontSize: 20, float: 'right' }}
        ></Typography>
      </Card>
    </div>
  );
};

export default HeaderBar;
